/**
 * Task 35877: Angular's reactive Validators.required, kept for signal forms. The signal-forms
 * required() also treats false and NaN as empty, so a form converted off ReactiveForms that must
 * keep blocking (or passing) exactly the same values uses these instead.
 */

/** Validators.required's emptiness test: only null, undefined, an empty string and an empty array are empty. */
export function isEmptyInputValue(value: unknown): boolean {
  return (
    value == null ||
    ((typeof value === 'string' || Array.isArray(value)) && value.length === 0)
  );
}

/** Validators.required, as a signal-form validate() rule. */
export const requiredAsReactive = ({ value }: { value: () => unknown }) =>
  isEmptyInputValue(value()) ? { kind: 'required' } : null;
